import React, { Fragment, useCallback, useState } from 'react';
import { Input, Button, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import ConfirmButton from '../Modal/ConfirmButton';
import { Prompt } from 'react-router-dom';

const toISODate = (val) => {
    const s = String(val || '');
    // already ISO-ish
    if (s.length >= 10 && s[4] === '-' && s[7] === '-') return s.substring(0, 10);
    // handle M/D/YYYY or MM/DD/YYYY
    const m = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
    if (m) {
        const mm = String(m[1]).padStart(2, '0');
        const dd = String(m[2]).padStart(2, '0');
        return `${m[3]}-${mm}-${dd}`;
    }
    return s.substring(0, 10);
};

const EditContactsNote2 = (props) => {
    const {
        row,
        activityList,
        editNote,
        deleteNote,
        handleEditSwap,
    } = props;

    const [date, setDate] = useState(toISODate(row?.date));
    const [typeID, setTypeID] = useState(row?.typeID || 0);
    const [notes, setNotes] = useState(row?.notes || '');
    const [unsavedChanges, setUnsavedChanges] = useState(false);

    const onSave = useCallback(() => {
        setUnsavedChanges(false);
        if (editNote) editNote(row.id, date, typeID, notes);
    }, [editNote, row?.id, date, typeID, notes]);

    const onDelete = useCallback(() => {
        setUnsavedChanges(false);
        if (deleteNote) deleteNote(row.id);
    }, [deleteNote, row?.id]);

    const onCancel = useCallback(() => {
        setUnsavedChanges(false);
        if (handleEditSwap) handleEditSwap(0);
    }, [handleEditSwap]);

    return (
        <>
            <Prompt
                when={unsavedChanges}
                message="You have unsaved changes, are you sure you want to leave?"
            />

            <Row>
                <Col className="pr-2">
                    <Input
                        type="date"
                        name="date"
                        value={date}
                        onChange={(e) => {
                            setDate(e.target.value);
                            setUnsavedChanges(true);
                        }}
                    />
                </Col>

                <Col className="pl-0">
                    <Fragment>
                        <Input
                            type="select"
                            name="typeID"
                            value={typeID}
                            onChange={(e) => {
                                setTypeID(parseInt(e.target.value, 10) || 0);
                                setUnsavedChanges(true);
                            }}
                        >
                            <option value="0">ACTIVITY</option>
                            {activityList
                                .filter(item => item.longDescription !== 'Other')
                                .map(item => (
                                    <option key={item.ID} value={item.ID}>
                                        {item.longDescription}
                                    </option>
                                ))}
                        </Input>
                    </Fragment>
                </Col>
            </Row>

            <Row className="mt-2">
                <Col>
                    <Input
                        type="textarea"
                        name="notes"
                        rows={15}
                        value={notes}
                        onChange={(e) => {
                            setNotes(e.target.value);
                            setUnsavedChanges(true);
                        }}
                    />
                </Col>
            </Row>

            <Row className="mt-2 text-right">
                <Col>
                    <Button
                        disabled={notes === ''}
                        className="mx-1"
                        color="success"
                        onClick={onSave}
                        title="Edit Note"
                    >
                        <FontAwesomeIcon icon={faCheck} />
                    </Button>

                    <ConfirmButton
                        className="mx-2"
                        color="danger"
                        onClick={onDelete}
                        title="Delete Note"
                    >
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </ConfirmButton>

                    <Button
                        className="mx-1"
                        color="secondary"
                        onClick={onCancel}
                        title="Cancel"
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                </Col>
            </Row>
        </>
    );
};

export default EditContactsNote2;